/** @format */

import { Checkbox, FormControlLabel, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import SimpleSelectRest from '../../../../components/Adescom/SimpleSelectRest';
import InputFormRest from '../../../../components/Form/InputFormRest';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import I18n from '../../../../components/Translate/I18n';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import PricelistSchemaElementInterface from '../../../../interfaces/billing/PricelistSchemaElementInterface';
import { RateHelper } from '../../../../helpers/RateHelper';
import RateSchemaInterface from '../../../../interfaces/billing/RateSchemaInterface';
import oplAppStyle from '../../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';

interface PricelistSchemaElementDetailsProps {
    classes: any;
    entity: PricelistSchemaElementInterface;
    entityStatus: any;
    changeInput: (e: any, stateName: string, type: string, require: boolean, maxValue: number, minValue: number) => void;
    changeSelect: (e: any, stateName: string, require: boolean) => void;
    changeRateSelect: (e: any, stateName: string, require: boolean) => void;
    togglePremiumPricelistCheckbox: (event: any) => void;
    toggleStrictPrefixMatch: (event: any) => void;
    premiumPricelist: boolean;
    setRateEntity: (entity: RateSchemaInterface) => void;
    rateEntity: RateSchemaInterface;
}

export const PricelistSchemaElementDetails = (props: PricelistSchemaElementDetailsProps): React.ReactElement => {
    const { changeInput, entity, entityStatus, changeSelect, setRateEntity, rateEntity, changeRateSelect, classes } = props;

    // TODO: Hardcoded - change at the end of work
    const vatCollections = {
        'hydra:member': [
            {
                mainname: '23%',
                value: '23',
            },
        ],
    };

    const typeCollections = {
        'hydra:member': [
            { name: 'Połączenie głosowe', value: 0 },
            { name: 'Usługa', value: 1 },
        ],
    };

    const subTypeCollection = {
        'hydra:member': RateHelper.mapRateConstantsNoUndefined(),
    };

    const subTypeCheckboxCallback = (event: any): void => {
        if (!event.target.checked) {
            setRateEntity({ ...rateEntity, subtype: null });
        } else {
            setRateEntity({ ...rateEntity, subtype: subTypeCollection['hydra:member'][0].value });
        }
    };

    // TODO: Missing currency records in DB. At this moment this column can be null

    return (
        <GridContainer>
            <GridItem xs={8}>
                <GridContainer>
                    <GridItem xs={12}>
                        <InputFormRest
                            classes={classes}
                            callback={changeInput}
                            stateName="mainname"
                            stateObjectState={entityStatus.mainname}
                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                            typeField={FormGeneralHelper.TYPE_TEXT}
                            displayFieldName="pricelists:h.pricelist_schema_element_name"
                            required={false}
                            vMax={255}
                            vMin={0}
                            value={entity.mainname}
                        />
                    </GridItem>
                    <GridItem xs={12}>
                        <SimpleSelectRest
                            callback={changeSelect}
                            restElements={vatCollections}
                            stateName="vat"
                            idState="id"
                            idSelected={entity.vat}
                            propKey="value"
                            required={false}
                            propValue="mainname"
                            emptyLabel="general:common.empty_label"
                            label="general:common.vat_amount"
                        />
                    </GridItem>
                    <GridItem xs={12}>
                        <SimpleSelectRest
                            callback={changeSelect}
                            restElements={typeCollections}
                            stateName="type"
                            idState="type"
                            idSelected={entity.type}
                            propKey="value"
                            required={false}
                            propValue="name"
                            emptyLabel="general:common.empty_label"
                            label="pricelists:h.type"
                        />
                    </GridItem>
                    <GridItem xs={12} md={5} lg={5} style={{ height: 50 }}>
                        <FormControlLabel
                            control={<Checkbox checked={!!rateEntity.subtype} onClick={subTypeCheckboxCallback} name="subType" color="primary" />}
                            label={<I18n trans={'pricelists:h.rate_subtype'} />}
                        />
                    </GridItem>
                    <GridItem xs={12} md={7} lg={7} style={{ height: 50 }}>
                        {!!rateEntity.subtype && (
                            <SimpleSelectRest
                                callback={changeRateSelect}
                                restElements={subTypeCollection}
                                stateName="subtype"
                                idState="subtype"
                                idSelected={rateEntity.subtype}
                                propKey="value"
                                required={false}
                                propValue="name"
                                emptyLabel="general:common.empty_label"
                                label="pricelists:h.select_subtype"
                            />
                        )}
                    </GridItem>

                    <GridItem xs={12}>
                        <FormControlLabel
                            control={<Checkbox checked={entity.premium} onClick={(): void => {}} name="premium" color="primary" />}
                            label={<I18n trans={'pricelists:h.pricelist_premium'} />}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={entity.strictPrefixMatch}
                                    onClick={props.toggleStrictPrefixMatch}
                                    name="strictPrefixMatch"
                                    color="primary"
                                />
                            }
                            label={<I18n trans={'pricelists:h.strict_prefix_match'} />}
                        />
                    </GridItem>

                    {/* <CheckBoxFormRest stateName="inout" checked={entity.inout} label={'tariffs:t.incoming'} callback={changeCheckbox} />
                        <CheckBoxFormRest stateName="prepaid" checked={entity.prepaid} label={'tariffs:t.prepaid'} callback={changeCheckbox} />
                        <CheckBoxFormRest
                        stateName="operatorsTariff"
                        checked={entity.}
                        label={'tariffs:t.operators_tariff'}
                    callback={changeCheckbox} */}
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(PricelistSchemaElementDetails);
